import React from "react";

// Need to do this as workaroudn known issue, https://github.com/akiran/react-slick/issues/1130
export const SlickButtonFix = (props: {
  children: React.ReactNode;
  slideCount?: number;
  currentSlide?: number;
}) => {
  const { children, ...others } = props as {
    children: React.ReactNode;
  } & React.HTMLAttributes<HTMLSpanElement>;
  return <span {...others}>{children}</span>;
};
